export default function MarkerHighlight(point, container, color, done_callback) {
    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 200;
    canvas.style.position = 'absolute';
    canvas.style.left = `${point.x - 100}px`;
    canvas.style.top = `${point.y - 100}px`;
    canvas.style.pointerEvents = 'none';
    const rgb = {
        r: parseInt(color.substr(1, 2), 16),
        g: parseInt(color.substr(3, 2), 16),
        b: parseInt(color.substr(5, 2), 16),
    };
    let count = -5;
    const max = 20;
    const intervalID = setInterval(function () {
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.save();
            ctx.beginPath();
            ctx.clearRect(0, 0, 200, 200);
            for (let i = 0; i < 2; i++) {
                const current = count + i * 5;
                if (current <= 0)
                    continue;
                const tone = parseInt(((255 / max) * current).toString(), 10);
                const alpha = 1 - (1 / max) * current;
                const color_ring = 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + alpha + ')';
                ctx.strokeStyle = color_ring;
                ctx.lineWidth = 4;
                ctx.beginPath();
                ctx.arc(100, 100, (100 / max) * current, 0, Math.PI * 2, false);
                ctx.stroke();
            }
            ctx.restore();
        }
        if (++count == max) {
            clearInterval(intervalID);
            canvas.parentElement?.removeChild(canvas);
            if (done_callback)
                done_callback();
        }
    }, 30);
    (container ?? document.body).appendChild(canvas);
}
